<template>

  <div>

    <div class="title">
      <h4 >自动巡检运维中心</h4>
    </div >
    <el-form ref="form" class="login_container" label-width="70px" :inline="true" :model="form"  >
      <div class="textbox">
        <div style="font-size: larger;color: white;position: relative;text-align: left;padding-bottom: 35px">欢迎登陆</div>
      </div>
      <el-form-item >

        <el-input  prefix-icon="User" ref="usernameInput" v-model="form.username" placeholder="用户名"></el-input>
      </el-form-item>
      <el-form-item >

        <el-input
            prefix-icon="unlock"
            ref="passwordInput"
            v-model="form.password"
            placeholder="密码"
            show-password
        >
        </el-input>
      </el-form-item>

      <div class="login_button" >
        <el-form-item prop="login">
          <el-button  type="primary" @click="submit"   :disabled="isLock" style="width: 275px;margin-top: 40px ">登录</el-button>
        </el-form-item>
      </div>
    </el-form>
    <div class="footer" style="font-size: small;color: white;text-align: center">
        ©2024 推荐使用:Microsoft Edge 平台版本:122.0.2365.80
    </div>
  </div>
</template>

<script>
// import Cookie from 'js-cookie'

import axios from "axios";
import {ElMessage} from "element-plus";
import {useStore} from "vuex";
import store from "@/store";
import CryptoJS from "crypto-js";

export default {
  name: "Login",
  data() {
    let store = useStore();
    return {
      form: {
        username: '',
        password: ''
      },
      SecretKey:"bohua",
      isLock:false,
      showPassword: false,
      isRemebered:false,
      rules: {
        username: [
          {required: true, trigger: 'blur', message: '请输入用户名'}
        ],
        password: [
          {required: true, trigger: 'blur', message: '请输入密码'}
        ],
      },
      value: '管理员'
    }
  },
  mounted() {

    // this.autoLogin();
    // 监听回车键事件
    document.addEventListener('keyup', this.handleKeyPress);
  },
  beforeUnmount() {
    // 移除键盘事件监听器
    document.removeEventListener('keyup', this.handleKeyPress);
  },
  methods: {


    autoLogin()
    {

      this.isRemebered = localStorage.getItem("isRemebered");
      if(this.isRemebered)
      {
        this.form.password = localStorage.getItem("password");
        this.form.username = localStorage.getItem("username");
      }

      if(localStorage.getItem("username")!=null&&localStorage.getItem("username")!='')
      {
        this.submit();
      }
    },

    // 登录
    submit() {
      localStorage.setItem("isRemebered",false);
      this.isLock = true;
      setTimeout(() => {
        this.isLock = false
      }, 2000)

      // localStorage.setItem("isRemebered",true);
      axios.post('/api1/login',this.form)
          .then(response =>{
            if(response.data.code == 200) {
              console.log(response)
              localStorage.setItem("username",this.form.username);
              localStorage.setItem("password",this.form.password);

              if (this.form.username == "admin")
              {
                ElMessage.success("您的身份是管理员")
              }
              store.state.username = this.form.username;
              store.state.privilege = this.form.privilege;
              store.state.isadmin = this.form.isadmin;

              this.$router.push('/OverView');
            } else {
              ElMessage.error("用户名或密码错误");
            }
          })
          .catch(error =>{
            console.log(error);
            ElMessage("登陆失败");
          })
    },
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },
    handleKeyPress(event) {
      if (event.key === 'Enter') {
        this.submit();
      }
    },
  }
}
</script>

<style lang="scss">
html{
  background-color: #2c3242;
  background-image: url("~@/assets/background.png");
  background-size: cover;
}
.title {
  font-size: 40px;
  color: white;
  text-align: center;
  margin-top: 100px;

}
.login_container {
  display: flex;
  flex-direction: column;
  //align-items: center;
  width: 350px;

  border: 1px solid #3c8dbc;
  margin: 180px auto;
  padding: 35px 35px 15px 35px;
  background-color: rgba(48, 55, 73, 0.5);

  border-radius: 8px;
  box-shadow: 0 0 25px rgba(48, 55, 73, 0.8);
  box-sizing: border-box;
  color: #3c8dbc;

  .select {
    width: 198px !important;
  }


  .el-input {
    width: 275px;
    flex:1;

  }
  .login_button {

  }
  .el-form-item {
    padding-bottom: 10px;
    display: flex;
    align-items: center;
    color: #3c8dbc;


    .el-form-item__label {
      width: 0px;

      color: #3c8dbc;
    }
  }
}
</style>